import script from "./MilitaryPolice.vue?vue&type=script&lang=ts&setup=true"
export * from "./MilitaryPolice.vue?vue&type=script&lang=ts&setup=true"

import "./MilitaryPolice.vue?vue&type=style&index=0&id=6d623893&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d623893"]])

export default __exports__